export default __webpack_public_path__ + "a3aad43bae68df544cf09249745434eb.png";